export const googleMapMixin = {
  methods: {
    isValidCoordinate(coordinate) {
      if (!coordinate) {
        return false
      }
      //do not do pos.hasOwnProperty('lat'), but rather Object.prototype.hasOwnProperty.call(pos, 'lat')
      //read more: https://eslint.org/docs/rules/no-prototype-builtins
      let isValid_lat = this.hasProperty(coordinate, 'lat') && this.isNumeric(coordinate.lat) && coordinate.lat >= -90 && coordinate.lat <= 90
      let isValid_lng = this.hasProperty(coordinate, 'lng') && this.isNumeric(coordinate.lng) && coordinate.lng >= -180 && coordinate.lng <= 180
      console.log('isValid_lat', isValid_lat)
      console.log('isValid_lng', isValid_lng)
      return isValid_lat && isValid_lng
    }
  }
}
